/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Sendarialabel3Inputs */

const en_coinvestments_messages_sendarialabel3 = /** @type {(inputs: Coinvestments_Messages_Sendarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reply`)
};

/**
* | output |
* | --- |
* | "Send reply" |
*
* @param {Coinvestments_Messages_Sendarialabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_sendarialabel3 = /** @type {((inputs?: Coinvestments_Messages_Sendarialabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Sendarialabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_sendarialabel3(inputs)
});
export { coinvestments_messages_sendarialabel3 as "coInvestments_messages_sendAriaLabel" }